import beautyImage from '@perpay-web/fintech/assets/categories/Beauty.png';
import electronicsImage from '@perpay-web/fintech/assets/categories/Electronics.png';
import handbagsImage from '@perpay-web/fintech/assets/categories/Handbags_and_Jewelry.png';
import homeImage from '@perpay-web/fintech/assets/categories/Home.png';
import kidsImage from '@perpay-web/fintech/assets/categories/Kids.png';
import lifestyleImage from '@perpay-web/fintech/assets/categories/Lifestyle.png';
import newImage from '@perpay-web/fintech/assets/categories/New.png';
import outdoorLivingImage from '@perpay-web/fintech/assets/categories/Outdoor_Living.png';
import {
    BEAUTY_CATEGORY,
    ELECTRONICS_CATEGORY,
    HANDBAGS_JEWELRY_CATEGORY,
    HOME_CATEGORY,
    KIDS_CATEGORY,
    LIFESTYLE_CATEGORY,
    NEW_PRODUCTS_CATEGORY,
    OUTDOOR_LIVING_CATEGORY,
} from '@perpay-web/fintech/constants/shopCategories';

export const CATEGORIES = [
    {
        title: 'Electronics',
        image: electronicsImage,
        link: ELECTRONICS_CATEGORY,
    },
    {
        title: 'Beauty',
        image: beautyImage,
        link: BEAUTY_CATEGORY,
    },
    {
        title: 'New Products',
        image: newImage,
        link: NEW_PRODUCTS_CATEGORY,
    },
    {
        title: 'Home',
        image: homeImage,
        link: HOME_CATEGORY,
    },
    {
        title: 'Outdoor Living',
        image: outdoorLivingImage,
        link: OUTDOOR_LIVING_CATEGORY,
    },
    {
        title: 'Handbags & Jewelry',
        image: handbagsImage,
        link: HANDBAGS_JEWELRY_CATEGORY,
    },
    {
        title: 'Toys & Baby',
        image: kidsImage,
        link: KIDS_CATEGORY,
    },
    {
        title: 'Lifestyle',
        image: lifestyleImage,
        link: LIFESTYLE_CATEGORY,
    },
];
